import _ from 'lodash'
import axios from 'axios';

        

    function getServiceName() {
       return localStorage.getItem("projectIp");
    }
    

    function getUiIp() {
        let prod = `${window.location.protocol}//${window.location.host}:443/`;
        console.log("UI", prod);
        return _.isEqual(process.env.NODE_ENV, "development")?"http://localhost:3000/":prod;
     }

     function getBalerionIp(){
         // backend (Balerion) is served from auth.theteam.brandlytics.co on the default https port (443)
         let prod = `${window.location.protocol}//auth.theteam.brandlytics.co/`;
         console.log("prod", prod);
         return _.isEqual(process.env.NODE_ENV, "development")?"http://23.21.147.166:7877/":prod;
     }

     function RequestNewToken(){
         localStorage.clear();
         window.location.href = `${getUiIp()}#/login`
     }

     /**
      * Handle API errors appropriately - only redirect to login for auth errors
      * @param {Error} err - Axios error object
      * @returns {boolean} - true if it was an auth error and redirect happened
      */
     function handleApiError(err) {
         // Check if it's an authentication error (401 or 403)
         if (err.response && (err.response.status === 401 || err.response.status === 403)) {
             RequestNewToken();
             return true;
         }
         // For other errors, just log them - don't redirect to login
         console.error('API Error:', err.message || err);
         return false;
     }

    console.log("called !! ")
    var Dimple = getUiIp();
    
    const BlueMoon = {}
    if(!(_.isEmpty(localStorage.getItem('projectIp') ) && localStorage.getItem('projectIp') != "undefined")){
        console.log("is getting assinged !! ")
        BlueMoon['ip'] = localStorage.getItem('projectIp') + "/";
        // BlueMoon['ip'] = "http://localhost:8083/";
    }
    var RequestToken = RequestNewToken;
    var handleError = handleApiError;
    var Balerion = getBalerionIp();

export {BlueMoon, Dimple, RequestToken, handleError, Balerion};
